(function () {
        'use strict';
        angular
            .module('ipmApp')
            .factory('PatientAgreementsService', PatientAgreementsService);

        PatientAgreementsService.$inject = ['$q', 'halClient', '$http'];

        function PatientAgreementsService($q, halClient, $http) {
            var baseUrl = 'api/agreement';
            var service = {
                "getAllAgreementForSelect": getAllAgreementForSelect,
                "saveAgreement" : saveAgreement
            };

            function getAllAgreementForSelect(patientId, type) {
                var deferred = $q.defer();
                var url = baseUrl + '/get-all-agreement-for-select?patientId=' + patientId + '&type=' + type;
                $http.get(url).success(function (data) {
                    deferred.resolve(data !== undefined ? data : []);
                }).error(function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }

            function saveAgreement(patientId, agreement) {
                var url = baseUrl + '/update';
                var patientAgreementUpdateRequest = {
                    "patientId": patientId,
                    "agreement": agreement
                }
                return $http.post(url, patientAgreementUpdateRequest).then(function (resp) {
                    return resp.data;
                });
            }

            return service;
        }
    }
)();
